import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=fde016c2&scoped=true"
import script from "./instruction.vue?vue&type=script&lang=js"
export * from "./instruction.vue?vue&type=script&lang=js"
import style0 from "./instruction.vue?vue&type=style&index=0&id=fde016c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde016c2",
  null
  
)

export default component.exports